import { styled } from 'styled-system/jsx'

const MessageStack = styled('div', {
  base: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
  },
})

const Heading = styled('span', {
  base: {
    fontFamily: 'body',
    fontSize: '16px',
    fontWeight: '700',
    color: 'quickpass.ink',
  },
})

const ThreadList = styled('div', {
  base: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    maxHeight: '320px',
    overflowY: 'auto',
  },
})

const MessageRow = styled('div', {
  base: {
    display: 'flex',
  },
  variants: {
    align: {
      start: { justifyContent: 'flex-start' },
      end: { justifyContent: 'flex-end' },
    },
  },
})

const Bubble = styled('div', {
  base: {
    display: 'flex',
    flexDirection: 'column',
    gap: '3px',
    maxWidth: '80%',
    paddingX: '14px',
    paddingY: '10px',
    borderRadius: '12px',
    border: '1px solid',
  },
  variants: {
    tone: {
      pm: { backgroundColor: 'white', borderColor: '#E7E3F1' },
      resident: { backgroundColor: 'quickpass.primarySoft', borderColor: '#D8CCFF' },
      warning: { backgroundColor: '#FFF6E0', borderColor: '#F1D99A' },
      retracted: {
        backgroundColor: '#F4F4F6',
        borderColor: '#D4D2DB',
        borderStyle: 'dashed',
      },
    },
  },
})

const AttachmentRow = styled('div', {
  base: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '6px',
    marginTop: '2px',
  },
})

const AttachmentThumb = styled('img', {
  base: {
    width: '88px',
    height: '88px',
    objectFit: 'cover',
    borderRadius: '8px',
    border: '1px solid #E7E3F1',
    cursor: 'pointer',
  },
})

const RetractedText = styled('span', {
  base: {
    fontFamily: 'body',
    fontSize: '13px',
    fontStyle: 'italic',
    color: '#9A9A9A',
    textDecoration: 'line-through',
  },
})

const RetractedNote = styled('span', {
  base: {
    fontFamily: 'body',
    fontSize: '11px',
    color: 'quickpass.inkSoft',
  },
})

const WarningBadge = styled('span', {
  base: {
    fontFamily: 'body',
    fontSize: '10px',
    fontWeight: '700',
    color: '#A05A16',
    textTransform: 'uppercase',
    letterSpacing: '0.4px',
  },
})

const MessageText = styled('span', {
  base: {
    fontFamily: 'body',
    fontSize: '14px',
    lineHeight: '1.45',
    color: 'quickpass.ink',
    whiteSpace: 'pre-wrap',
  },
})

const MessageMeta = styled('span', {
  base: {
    fontFamily: 'body',
    fontSize: '11px',
    color: 'quickpass.inkSoft',
  },
})

const NewBadge = styled('span', {
  base: {
    alignSelf: 'flex-start',
    paddingX: '8px',
    paddingY: '1px',
    borderRadius: 'pill',
    backgroundColor: 'quickpass.primary',
    color: 'white',
    fontFamily: 'body',
    fontSize: '9px',
    fontWeight: '700',
    textTransform: 'uppercase',
    letterSpacing: '0.4px',
  },
})

const AckNote = styled('span', {
  base: {
    fontFamily: 'body',
    fontSize: '11px',
    fontWeight: '600',
    color: '#1E7A4D',
  },
})

const AckRow = styled('div', {
  base: {
    display: 'flex',
    marginTop: '2px',
  },
})

const EmptyText = styled('p', {
  base: {
    margin: '0',
    fontFamily: 'body',
    fontSize: '13px',
    color: 'quickpass.inkSoft',
  },
})

const ReplyRow = styled('div', {
  base: {
    display: 'flex',
    gap: '8px',
    alignItems: 'flex-end',
  },
})

const ReplyInput = styled('input', {
  base: {
    flex: '1',
    paddingX: '12px',
    paddingY: '10px',
    borderRadius: '10px',
    border: '1px solid #E7E3F1',
    fontFamily: 'body',
    fontSize: '15px',
    color: 'quickpass.ink',
    backgroundColor: 'white',
  },
})

export {
  MessageStack,
  Heading,
  ThreadList,
  MessageRow,
  Bubble,
  AttachmentRow,
  AttachmentThumb,
  RetractedText,
  RetractedNote,
  WarningBadge,
  MessageText,
  MessageMeta,
  NewBadge,
  AckNote,
  AckRow,
  EmptyText,
  ReplyRow,
  ReplyInput,
}
